import { render, staticRenderFns } from "./bing.vue?vue&type=template&id=842567a4&scoped=true"
import script from "./bing.vue?vue&type=script&lang=js"
export * from "./bing.vue?vue&type=script&lang=js"
import style0 from "./bing.vue?vue&type=style&index=0&id=842567a4&prod&scss=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842567a4",
  null
  
)

export default component.exports